import { useEffect, useRef } from "react";
import { useLocation } from "wouter";
import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/use-auth";

export default function PublicGuestClaimPage() {
  const { user, isLoading } = useAuth();
  const [, navigate] = useLocation();
  const claimedRef = useRef(false);

  const claimMutation = useMutation({
    mutationFn: async () => {
      const res = await apiRequest("POST", "/api/guest/claim");
      if (!res.ok) throw new Error("Claim failed");
      return res.json();
    },
    onSuccess: (data: { quoteId: string | null; claimed: boolean; conflict?: boolean }) => {
      if (data.quoteId) {
        navigate(`/quotes/${data.quoteId}`);
      } else {
        navigate("/");
      }
    },
    onError: () => {
      navigate("/");
    }
  });

  useEffect(() => {
    if (isLoading) return;
    if (!user) {
      navigate("/login?returnTo=/try-a-quote/claim");
      return;
    }
    if (!claimedRef.current) {
      claimedRef.current = true;
      claimMutation.mutate();
    }
  }, [user, isLoading, navigate, claimMutation]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <Loader2 className="h-10 w-10 animate-spin mx-auto text-primary" />
        <p className="text-muted-foreground text-sm font-medium">Saving your quote...</p>
      </div>
    </div>
  );
}